// extracted by mini-css-extract-plugin
module.exports = {"container":"tagsSearch_container__1TIsj","close":"tagsSearch_close___DcRo"};